import Api from '@/api/Api';
import uploadWithAuth from '@/api/ApiUpload';
import errorHandler from '@/utils/plugins/ErrorHandler';

const RESOURCE_NAME = '/api/collaborators';
const RESOURCE_MEDIA_OBJECT = '/media_objects';
//const RESOURCE_ABSENCE_SUPPORTING_DOCUMENT = '/absence_supporting_documents';


export default {

    // COLLABORATORS
    async get(resource){
        return Api()
            .get(resource)
            .catch((err) => errorHandler(err, null));
    },
    getCollaborators(params) {
        return Api()
            .get(RESOURCE_NAME, { params: params })
            .catch((err) => errorHandler(err, null));
    },
    getSystemCollaborators(params) {
        return Api()
            .get(RESOURCE_NAME+'?active=1&job.name=Administrador de Sistemas', { params: params })
            .catch((err) => errorHandler(err, null));
    },
    getCollaborator(id) {
        return Api().get(RESOURCE_NAME + `/${id}`)
            .catch((err)=> errorHandler(err, null));
    },
    createCollaborator(item) {
        return Api().post(RESOURCE_NAME, item)
            .catch((err) => errorHandler(err, null));
    },
    updateCollaborator(item, id) {
        return Api().put(RESOURCE_NAME + `/${id}`, item)
            .catch((err) => errorHandler(err, null));
    },
    deleteCollaborator(id) {
        return Api().delete(RESOURCE_NAME + `/${id}`)
            .catch((err) => errorHandler(err, null));
    },
    uploadImageFile( file) {
        let formData = new FormData();
        formData.append('file', file);
        return uploadWithAuth({
            method: 'post',
            url: process.env.VUE_APP_API_URI + RESOURCE_MEDIA_OBJECT,
            data: formData,
            headers: { 'Content-Type': 'multipart/form-data', 'Accept': 'application/ld+json' },
            errorHandle: false
        })
            .catch(error => {
                console.log('Error: ' + error.response)
            })

    },
    getImageCollaborator(id) {
        return Api()
            .get(id)
            .catch((err) => errorHandler(err, null));
    },
    deleteImageCollaborator(id) {
        return uploadWithAuth({
            method: 'delete',
            url: process.env.VUE_APP_API_URI + RESOURCE_MEDIA_OBJECT + '/' + id,
            headers: { 'Content-Type': 'multipart/form-data', 'Accept': 'application/ld+json' },
            errorHandle: false
        })
            .catch(error => {
                console.log('Error: ' + error.response)
            })
    },

}

